// extracted by mini-css-extract-plugin
export var externalLink = "_9u-0";
export var internalLinkLabel = "_9u-1";